import {useState} from 'react'
import GradeDetailsForm from './GradeDetailsForm';
import GradeDetailsList from './GradeDetailsList';

const GradeDetails = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");
  
  return (
    <>
      {fromIsShown ? (
          <GradeDetailsForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
        ) : (
          <GradeDetailsList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
  }

export default GradeDetails